/**
 * Serialize the WLS search `amenities` state into the query-string param the
 * WLS search API expects, or `undefined` when nothing is selected.
 *
 * Property/RV search stores selected amenities in one of two shapes:
 *   - Property brands: an object `{ Property: [...], Unit: [...] }` produced by
 *     `getAmenitiesFromParams`.
 *   - RV-fleet brands: an array of vehicle column names produced by
 *     `vehicleAmenitiesFromParams`.
 *
 * Both are forwarded verbatim as a JSON string; empty/null selections are
 * omitted so an unfiltered search is unaffected.
 */
const serializeAmenitiesParam = amenities => {
  if (!amenities) return undefined;

  if (Array.isArray(amenities)) {
    return amenities.length ? JSON.stringify(amenities) : undefined;
  }

  if (typeof amenities === 'object') {
    const hasSelection = Object.values(amenities).some(
      value => Array.isArray(value) && value.length > 0
    );
    return hasSelection ? JSON.stringify(amenities) : undefined;
  }

  return undefined;
};

module.exports = serializeAmenitiesParam;
module.exports.serializeAmenitiesParam = serializeAmenitiesParam;
